import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ContactForm from '../contact-us/contact-form.component';

const MyModal = ({ show, setShow }) => {
  // const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ContactForm closeForm={handleClose} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MyModal;
